export const FORMATS = [
  { v: "single_elimination", label: "Single Elimination", desc: "One loss and you're out." },
  { v: "double_elimination", label: "Double Elimination", desc: "A second chance for every team." },
  { v: "round_robin", label: "Round Robin", desc: "Everyone plays each other." },
  { v: "groups", label: "Groups + Knockout", desc: "Group stage followed by playoffs." },
];
export const FORMAT_LABEL = Object.fromEntries(FORMATS.map((f) => [f.v, f.label]));
export const T_STATUSES = [
  { v: "registration", label: "Registration Open" },
  { v: "upcoming", label: "Upcoming" },
  { v: "live", label: "Live" },
  { v: "completed", label: "Completed" },
];
export const SECTION_LABEL = {
  main: "Bracket", upper: "Upper Bracket", lower: "Lower Bracket", final: "Grand Final",
  third: "Third Place", rr: "Round Robin", group: "Group Stage", playoffs: "Playoffs",
};
export const EMPTY_TOURNAMENT = {
  name: "", game: "", format: "single_elimination", description: "", cover: "", start_date: "", end_date: "",
  timezone: "(GMT+7) Jakarta, Asia", prize_pool: "", location: "Online", online: true, max_teams: 16, team_size: 5,
  match_format: "Best of 3", grand_final_format: "Best of 5", third_place: true, bracket_public: true,
  allow_score_submission: false, require_opponent_confirmation: false, registration_open: true,
  status: "registration", terms: "", group_size: 4, advance_per_group: 2,
};
export const TIMEZONES = [
  "(GMT-8) Los Angeles, America", "(GMT-5) New York, America", "(GMT+0) London, Europe", "(GMT+1) Warsaw, Europe",
  "(GMT+3) Istanbul, Europe", "(GMT+7) Jakarta, Asia", "(GMT+8) Singapore, Asia", "(GMT+9) Tokyo, Asia", "(GMT+10) Sydney, Australia",
];
export const inputCls = "w-full px-3 py-2.5 rounded-lg bg-black/30 border border-white/10 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[hsl(var(--primary))] transition-colors";
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: s.includes("T") ? "2-digit" : undefined, minute: s.includes("T") ? "2-digit" : undefined }) : "TBD");
